import { cva } from 'class-variance-authority';

export const cvaParkingIcon = cva([
  'ParkingIconStyles-cvaParkingIcon',
  'relative',
  'top-[-4rem] left-[-2rem]',
  'flex flex-col items-center gap-0.3',
]);

export const cvaParkingIconInner = cva([
  'ParkingIconStyles-cvaParkingIconInner',
  'flex justify-center items-center',
  'min-w-3.2 h-3',
  'bg-cGreen rounded-[0.4rem]',
]);
export const cvaParkingIconCount = cva([
  'ParkingIconStyles-cvaParkingIconCount',
  'block',
  'h-fit',
  'text-[2.4rem] font-extrabold leading-none text-cWhite',
]);
